import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'
import i00001 from '../images/favagas/00001.jpg'
import i00002 from '../images/favagas/00002.jpg'
import i00003 from '../images/favagas/00003.jpg'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,

    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <SubTitle>Fakivágás</SubTitle>
        <p>
          Ingyenes helyszíni felmérés és részletes árajánlat alapján, könnyen el tudja dönteni, hogy megoldja-e a
          kertjében lévő, fák okozta problémákat. Az elöregedett, vagy túl magasra nőtt fák kivágását bízza szakemberre.
          Alpintechnikával végzett munkák során a fákról először eltávolítjuk a gallyakat, majd fokozatosan fentről
          lefelé haladva a teljes törzs eltávolítására kerül sor, ezzel a technikával szakszerűen, pontosan lehet a fa
          darabjait a szűk, keskeny helyeken is biztonsággal a földre engedni. A gyökérzet, igény szerinti, kézi vagy
          gépi eltávolítására is van lehetőség.
        </p>
      </Section>
      <Section>
        <SubTitle>Gallyazás</SubTitle>
        <p>
          A gallyazás a növények ápolását, egészséges állapotuk megőrzését szolgálja. A visszavágás során a növény
          ifjítása történik meg, elősegíti a fák megújulását. A gallyazás munkálatai többek között hajtásválogatási,
          száraz ág eltávolítási, ingatlan állagvédelmi célzattal hajtjuk végre. A megrendelők sok esetben pedig a
          törvény által előírt kötelezettségük betartása miatt rendelik meg a szolgáltatást. A törvény ugyanis előírja,
          hogy a telektulajdonosoknak kötelességük a fák karbantartása. Azon túlmenően, hogy a Miniszteri rendelet
          szabályait betartjuk, mindenképpen vegyük figyelembe, hogy a nem megfelelően karbantartott fák akár
          emberéletet is követelhetnek. Gondoljunk itt az elektromos vezetékekhez hozzáérő faágakhoz, vagy az elkorhadt
          ágak viharos időjárás során történő leszakadására. A vezetékek mellé belógó ágak már közepes szélben is
          üzemzavart okozhatnak. A fák védelme érdekében a gallyazás utáni sebkezelés, faápolás is igényelhető!
        </p>
      </Section>
      <Section>
        <SubTitle>Veszélytelenítés</SubTitle>
        <p>
          Hazánkban egyre több, nagy erejű vihar tombol. Ennek következtében rengeteg fa szenved kisebb, nagyobb
          sérülést. Rosszabb esetben nemcsak a fa károsodik, hanem a környezete is. A viharok során kidőlt fák,
          leszakadt ágak az alattuk álló épületeket, gépkocsikat is károsíthatják. Minden évben emberéletet is
          követelnek a megrongálódott vagy beteg fák. Veszélytelenítési szolgáltatás során a balesetveszélyessé vált,
          sűrűn lakott területen lévő, kiszáradt, feleslegessé vált, vagy sérült fák eltávolítását végezzük.
        </p>
      </Section>
      <Section>
        <SubTitle id="kepek">Képek</SubTitle>
        <Images>
          <img src={i00001} alt="" />
          <img src={i00002} alt="" />
          <img src={i00003} alt="" />
        </Images>
        <ScrollIndicator>◀ ● ▶</ScrollIndicator>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
